import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";

import { GlobalProvider } from "./GlobalContext";

import MainLayout from "./Components/MainLayout";

import SettingsPage from "./Components/Settings/SettingsPage";
import TeamsPage from "./Components/Teams/TeamsPage";
import DriversPage from "./Components/Driver/DriversPage";
import BankPage from "./Components/Banks/BankPage";
import TasksPage from "./Components/Tasks/TasksPage";
import ReportsPage from "./Components/Reports/ReportsPage";
import LoginPage from "./Components/Login/LoginPage";
import ShopsPage from "./Components/Shops/ShopsPage";

import { Toaster } from "react-hot-toast";

import "./App.css";

import SlotManager from "./Components/Gigs/SlotManager";
import TierSection from "./Components/Tier/Tier";
import Notification from "./Components/Notification/Notification";
import IntroScreen from "../src/Components/Utils/IntroScreen";
import DashboardContainer from "./Components/MainDashboard/DashboardContainer";
import Attendance from "./Components/Attendance/Attendance";
import Settlement from "./Components/Settlement/Settlement";
import SettlementDetail from "./Components/Settlement/SettlementDetail";
import DriverAnalytics from "./Components/Reports/driverAnalytics/components/DriverAnalytics";
import Admin from "./Components/Admin/Admin";

import VolunteerLoginPage from "./Components/Login/VolunteerLoginPage";

import VolunteerAttendance from "./Components/Admin Volunteer/Attendance/VolunteerAttendance";
import VolunteerPage from "./Components/Admin Volunteer/Volunteer/VolunteerPage";

import VolunteerLayout from "./Components/Admin Volunteer/Utils/VolunteerLayout";

import VolunteerShopsPage from "./Components/Admin Volunteer/Shops List/VolunteerShopsList";

import VolunteerProtected from "./Components/Admin Volunteer/Utils/volunteerProtected";

import VolunteersBank from "./Components/Admin Volunteer/Banks/VolunteersBank";

import AdminProtected from "./Components/Utils/AdminProtected";

import Store from "./Components/Store/Store";

import DriverOrdersPage from "./Components/Driver/DriverOrdersPage";

import VolunteerSettlement from "./Components/Admin Volunteer/Settlement/VolunteerSettlement";

/* =========================================================
   GLOBAL FALLBACK
========================================================= */

function CatchAllRedirect() {
  const isAdminAuthenticated = !!sessionStorage.getItem("admin");

  const isVolunteerAuthenticated = !!sessionStorage.getItem("volunteerData");

  if (isAdminAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isVolunteerAuthenticated) {
    return <Navigate to="/volunteer" replace />;
  }

  return <Navigate to="/login" replace />;
}

/* =========================================================
   APP
========================================================= */

function App() {
  const [audioUnlocked, setAudioUnlocked] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("audioUnlocked") === "true") {
      setAudioUnlocked(true);
    }
  }, []);

  return (
    <Router>
      <GlobalProvider>
        {/* =================================================
            INTRO SCREEN
        ================================================= */}

        {!audioUnlocked && (
          <IntroScreen onContinue={() => setAudioUnlocked(true)} />
        )}

        <Toaster
          position="top-center"
          toastOptions={{
            duration: 5000,
          }}
        />

        <Routes>
          {/* ===============================================
              PUBLIC ROUTES
          =============================================== */}

          <Route path="/login" element={<LoginPage />} />

          <Route path="/volunteer/login" element={<VolunteerLoginPage />} />

          {/* ===============================================
              ADMIN ROUTES
          =============================================== */}

          <Route
            path="/"
            element={
              <AdminProtected>
                <MainLayout />
              </AdminProtected>
            }
          >
            {/* Default */}

            <Route index element={<Navigate to="/dashboard" replace />} />

            {/* =============================================
                MAIN ROUTES
            ============================================= */}

            <Route path="dashboard" element={<DashboardContainer />} />

            <Route path="settings" element={<SettingsPage />} />

            <Route path="teams" element={<TeamsPage />} />

            <Route path="driver" element={<DriversPage />} />

            <Route path="banks" element={<BankPage />} />

            <Route path="tasks" element={<TasksPage />} />

            <Route path="reports" element={<ReportsPage />} />

            <Route path="shops" element={<ShopsPage />} />

            <Route path="slots" element={<SlotManager />} />

            <Route path="tiers" element={<TierSection />} />

            <Route path="notifications" element={<Notification />} />

            <Route path="attendance" element={<Attendance />} />

            <Route path="settlement" element={<Settlement />} />

            <Route path="store" element={<Store />} />

            <Route path="admin" element={<Admin />} />

            {/* =============================================
                API NESTED ROUTES
                getUserAccess submenu_url mapping
            ============================================= */}

            {/* Tasks submenu */}

            <Route path="admin/clients" element={<TasksPage />} />

            {/* Driver nested routes */}

           {/* Operations */}
<Route path="operation/tasks" element={<TasksPage />} />
<Route path="operation/driver" element={<DriversPage />} />
<Route path="operation/teams" element={<TeamsPage />} />
<Route path="operation/slots" element={<SlotManager />} />
<Route path="operation/attendance" element={<Attendance />} />

{/* Business */}
<Route path="business/tier" element={<TierSection />} />
<Route path="business/shop" element={<ShopsPage />} />
<Route path="business/store" element={<Store />} />

{/* Finance */}
<Route path="finance/bank" element={<BankPage />} />
<Route path="finance/settlement" element={<Settlement />} />

{/* Reports */}
<Route path="reports/notification" element={<Notification />} />
<Route path="reports/reports" element={<ReportsPage />} />

{/* Administration */}
<Route path="administration/settings" element={<SettingsPage />} />
<Route path="administration/admin" element={<Admin />} />
            {/* =============================================
                DYNAMIC ROUTES
            ============================================= */}

            <Route
              path="drivers/orders/:driverId"
              element={<DriverOrdersPage />}
            />

            <Route
              path="analytics/:driverId/:username"
              element={<DriverAnalytics />}
            />

            <Route
              path="settlement-detail/:driverId/:username"
              element={<SettlementDetail />}
            />

            {/* =============================================
                UNKNOWN ADMIN ROUTE
            ============================================= */}

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>

          {/* ===============================================
              VOLUNTEER ROUTES
          =============================================== */}

          <Route
            path="/volunteer"
            element={
              <VolunteerProtected>
                <VolunteerLayout />
              </VolunteerProtected>
            }
          >
            <Route index element={<VolunteerPage />} />

            <Route path="shops" element={<VolunteerShopsPage />} />

            <Route path="attendance" element={<VolunteerAttendance />} />

            <Route path="bank" element={<VolunteersBank />} />

            <Route path="settlement" element={<VolunteerSettlement />} />

            <Route path="*" element={<Navigate to="/volunteer" replace />} />
          </Route>

          {/* ===============================================
              GLOBAL UNKNOWN ROUTE
          =============================================== */}

          <Route path="*" element={<CatchAllRedirect />} />
        </Routes>
      </GlobalProvider>
    </Router>
  );
}

export default App;
